import { render, staticRenderFns } from "./qc-statistics.vue?vue&type=template&id=24a5d20b&scoped=true"
import script from "./qc-statistics.vue?vue&type=script&lang=js"
export * from "./qc-statistics.vue?vue&type=script&lang=js"
import style0 from "./qc-statistics.vue?vue&type=style&index=0&id=24a5d20b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_css-loader@5.2.7_prettier@2.8.7_react-dom@17.0.2_react@_xbvnx5joxenxrdtaq55cnp74na/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a5d20b",
  null
  
)

export default component.exports